<template>
  <card-dialog
    v-model="modalVisible"
    max-width="700px"
    title="Edit song"
  >
    <v-card-text
      class="pa-6"
    >
      <validation-observer ref="validation">
        <validation-provider
          v-slot="{ errors }"
          rules="required"
        >
          <v-text-field
            v-model="fileDirty.artist"
            outlined
            :error-messages="errors"
            placeholder="Enter song artist"
          />
        </validation-provider>

        <validation-provider
          v-slot="{ errors }"
          rules="required"
        >
          <v-text-field
            v-model="fileDirty.title"
            outlined
            :error-messages="errors"
            placeholder="Enter song title"
          />
        </validation-provider>

        <div class="font-weight-bold mb-2">
          Set song attributes
        </div>
        <div
          v-for="attribute in attributes"
          :key="attribute.id"
        >
          <v-select
            v-model="selectedAttributes[attribute.id]"
            :label="attribute.title"
            :items="attribute.values"
            item-text="value"
            item-value="id"
            deletable-chips
            multiple
            outlined
            clearable
          />
        </div>
      </validation-observer>
    </v-card-text>
    <template v-slot:actions>
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn
          color="primary"
          :loading="submitting"
          @click="submit()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </template>
  </card-dialog>
</template>

<script>
import CardDialog from '@/components/helpers/CardDialog'
import LibraryFiles from '@/services/LibraryFiles'
import { cloneDeep } from 'lodash'

export default {
  name: 'EditLibraryFileDialog',
  components: { CardDialog },
  props: {
    file: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileDirty: cloneDeep(this.file),
      selectedAttributes: {},
      submitting: false
    }
  },
  computed: {
    modalVisible: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        this.$emit('update:visible', value)
      }
    },
    attributes() {
      return this.$store.state.attributes.data
    }
  },
  watch: {
    visible(value) {
      if (!value) return

      this.fileDirty = cloneDeep(this.file)

      this.prepareSelectedAttributes()
    }
  },
  created() {
    this.fileDirty = cloneDeep(this.file)

    this.prepareSelectedAttributes()
  },
  methods: {
    prepareSelectedAttributes() {
      this.selectedAttributes = {}

      if (this.file.attribute_values.length === 0) return

      const attributes = {}

      for (const attributeValue of this.file.attribute_values) {
        if (!attributes[attributeValue.attribute.id]) {
          attributes[attributeValue.attribute.id] = [attributeValue.id]
        } else {
          attributes[attributeValue.attribute.id].push(attributeValue.id)
        }
      }

      this.selectedAttributes = attributes
    },
    async submit() {
      if (!(await this.$refs.validation.validate())) {
        return
      }

      await this.save()
    },
    async save() {
      try {
        this.submitting = true

        await LibraryFiles.update(this.fileDirty.id, {
          artist: this.fileDirty.artist,
          title: this.fileDirty.title,
          attribute_values: Object.values(this.selectedAttributes).flat()
        })

        this.$emit('file:updated')

        this.$store.dispatch('alert', {
          text: 'Song successfully updated',
          color: 'success'
        })

        this.modalVisible = false
      } catch (e) {
        this.$store.dispatch('alert', {
          text: 'There were some errors updating the song',
          color: 'error'
        })
        throw e
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
